const required = (arg: unknown): string =>
  arg ? '' : 'Field cannot be empty.';

export default required;
